import { KeyboardArrowDownOutlined } from "@mui/icons-material";
import Box from "@mui/material/Box";
import { useState } from "react";

const SurveyRatingChoices = ({ selections, question, selectChoice, themeColors }) => {
    const [showOptions, setShowOptions] = useState(false);

    function handleSelectChoice(choiceValue) {
        if (selectChoice) {
            selectChoice(choiceValue, question.id);
        }
    }

    function onSelection(choice) {
        setShowOptions(false);

        handleSelectChoice(choice.value);
    }

    function toggleOption() {
        if (showOptions) {
            setShowOptions(false);
        } else {
            setShowOptions(true);
        }
    }

    function createDropdownText(selection) {
        if (selection === undefined && selection === null) {
            return "Select";
        }

        switch (selection) {
            case 0:
                return `Not good at all ${selection}`;
            case 10:
                return `Very good ${selection}`;
            default:
                return selection;
        }
    }

    return (
        <>
            <div className="body-text md:flex hidden flex-col gap-2 md:w-full" style={{ minWidth: "250px" }}>
                <div className="flex gap-2">
                    {question.choices &&
                        question.choices.map((choice, index) => (
                            <Box
                                key={index}
                                onClick={() => handleSelectChoice(choice.value)}
                                style={{
                                    backgroundColor:
                                        selections && selections[question.id] == choice.value
                                            ? themeColors.primaryColor + "33"
                                            : "",
                                    minWidth: "40px",
                                    width: "100%",
                                }}
                                className={`"text-[#5E718D]" c-box flex items-center justify-center p-2 cursor-pointer`}
                            >
                                <div>{choice.value}</div>
                            </Box>
                        ))}
                </div>
                <div className="col-span-11 flex justify-between mt-3 text-[#455468]">
                    <div>Not good at all</div>
                    <div className="mr-2">Very good</div>
                </div>
            </div>

            {/* This is only shown on screens that are less than 768px wide */}
            <div className="md:hidden">
                <div className="border border-slate-300 rounded-lg max-w-[400px] relative">
                    <div
                        onClick={toggleOption}
                        className="pb-3  p-3 flex justify-between items-center cursor-pointer select-none"
                    >
                        <div>{createDropdownText(selections && selections[question.id])}</div>

                        <KeyboardArrowDownOutlined className="text-lg"></KeyboardArrowDownOutlined>
                    </div>
                    {showOptions ? (
                        <div className="pt-3 py-3 border-t border-slate-300  select-none">
                            {question.choices.map((choice, i) => (
                                <div
                                    style={{
                                        background:
                                            selections &&
                                            selections[question.id] &&
                                            selections[question.id][choice.id] &&
                                            selections[question.id][choice.id].label == choice.label
                                                ? themeColors.secondaryColor + "33"
                                                : "",
                                    }}
                                    onClick={() => onSelection(choice)}
                                    key={i}
                                    className="p-3 hover:bg-slate-300 cursor-pointer"
                                >
                                    {choice.label}
                                </div>
                            ))}
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </>
    );
};

export default SurveyRatingChoices;
